class ProductUpsell extends HTMLElement {
  constructor() {
    super();

    this.upsellCarousel();

    this.upsellCarousel = new Swiper(this.querySelector('.product-upsell .swiper'), {
      slidesPerView: 2,
      freeMode: true,
      spaceBetween: 14,
      navigation: {
        nextEl: this.querySelector(".product-upsell .swiper-next"),
        prevEl: this.querySelector(".product-upsell .swiper-prev"),
      },
      pagination: {
        el: this.querySelector(".product-upsell .swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        1025: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
      },
    });

    this.attachClickEvent();
  } 
  attachClickEvent() {
    const buttons = this.querySelectorAll('.product-upsell__item-button');
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const upsellContainer = button.previousElementSibling; 
        const select = upsellContainer.querySelector('[data-upsell-select'); 
        if (select) {
          const variantId = select.value
          this.handleButtonClick(variantId, button);

        } else {
          const defaultId = upsellContainer.querySelector('[data-upsell-id'); 
          const variantId = defaultId.value
          this.handleButtonClick(variantId, button);
        }
      });
    });
  }

  handleButtonClick(variantId, buttonElement) {
    let body = {
      id: variantId,
      quantity: 1,
      sections: [
        "cart-drawer",
        "cart-icon-bubble"
      ],
      properties: {
        '_isUpsell': true
      }
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
    })
    .then(res => res.json())
    .then(res => {
      document.dispatchEvent(ThatWorks.pixelEvent.cart);
      ThatWorks.cartElement.renderContents(res);

      const parentElement = buttonElement.parentElement
      parentElement.classList.add('is-added')
      buttonElement.textContent = 'ADDED'

      const select = parentElement.querySelector('select')
      if (select) {
        select.disabled = true
      }
    });
  }

  upsellCarousel() {
  }
}

window.customElements.define('product-upsell', ProductUpsell);
window.ThatWorks.productElement = document.querySelector('product-upsell');
